import { FC, MouseEvent, ReactElement } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { Message } from './Message'

interface ConfirmDialogProps {
  open: boolean
  /**  If title is not specified, the Dialog does not render a Close button. */
  title?: string | ReactElement<any>
  renderCloseButton?: boolean
  id?: string
  args?: string[]
  renderCancelButton?: boolean
  context?: string
  width?: string | number
  height?: string | number
  okText?: string
  cancelText?: string
  onClickOk?: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
  onClickCancel?: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open = false,
  title,
  renderCloseButton = false,
  id,
  args,
  renderCancelButton = true,
  context,
  width = 600,
  height = 200,
  okText = 'はい',
  cancelText = 'いいえ',
  onClickOk,
  onClickCancel
}) => {
  // #region hooks start
  // #endregion hooks end

  // #region useEffect functions start
  // #endregion useEffect functions end

  // #region logic functions start
  const handleOnClickOk = (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    onClickOk?.(event)
  }

  const handleOnClickCancel = (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    onClickCancel?.(event)
  }
  // #endregion logic functions end

  // #region render functions start
  if (!open) {
    return null
  }

  return (
    <Dialog
      width={width}
      height={height}
      title={title === undefined && renderCloseButton ? ' ' : title}
      // fix if you need
      onClose={handleOnClickCancel as any}
    >
      {id !== undefined
        ? (
        <span>
          <Message id={id} args={args} />
        </span>
          )
        : (
        <span>{context}</span>
          )}
      <DialogActionsBar layout="end">
        {renderCancelButton && (
          <Button className="pcy-button-long" onClick={handleOnClickCancel}>
            {cancelText}
          </Button>
        )}
        <Button
          themeColor="primary"
          className="pcy-button-long"
          autoFocus
          onClick={handleOnClickOk}
        >
          {okText}
        </Button>
      </DialogActionsBar>
    </Dialog>
  )
  // #endregion render functions end
}
